export enum ChainId {
  MAINNET = 1,
  GOERLI = 5,
  OPGOERLI = 420,
  GNOSIS = 100,
}
